const Notifications = {
    "title": "Notifications",
    "subtitle": "Track activity updates and message alerts in one place.",
    "status_read": "Read",
    "status_unread": "Unread",
    "meta_from": "From",
    "meta_premise": "Premise",
    "empty": "No Notifications Found."
}

export default Notifications;